import type React from 'react'

import { createIC } from '@/helpers/idle'
import { useMountIdle } from '@/hooks/idle'

export interface IFacebookPixelProps {
  ids: string[]
}

const FacebookPixel: React.FC<IFacebookPixelProps> = (props) => {
  const { ids } = props

  useMountIdle(() => {
    const run = async () => {
      const FacebookPixelCore = (await import('react-facebook-pixel')).default

      ids.forEach((id) => {
        FacebookPixelCore.init(id)
      })

      createIC(() => {
        FacebookPixelCore.pageView()
      })
    }

    run()
  })

  return null
}

export default FacebookPixel
